import { createContext, Dispatch, SetStateAction } from "react"

export const AuthLayoutContext = createContext<{
	isMobileMenuOpen: boolean
	isDesktopMenuOpen: boolean
	setMobileMenuOpen: Dispatch<SetStateAction<boolean>>
	setIsDesktopMenuClosed: Dispatch<SetStateAction<boolean>>
}>(null!)
